import { useEffect } from "react";
import ReactGA from 'react-ga4';
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Box } from "@mui/material";
import "./App.css";
import Layout from "../components/Layout/Layout";
import Navigation from './Navigation';

const TRACKING_ID =  process.env.REACT_APP_GA_ID; 

const theme = createTheme({
  palette: {
    primary: {
      main: "#3BD6FF",
    },
    secondary: {
      main: "#001830",
    },
    common: {
      black: "#000",
      white: "#FFF",
    },
  },
  typography: {
    // page title
    h1: {
      fontFamily: "kippaxmodern_cndxbdlt",
      fontSize: "100px",
      color: "#3BD6FF",
      lineHeight: "92px",
      fontWeight: 400,
      letterSpacing: 0,
      textTransform: "uppercase",
    },
    // section title
    h2: {
      fontFamily: "kippaxmodern_cndbd",
      color: "var(--3, #FFF)",
      fontSize: "60px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "normal",
      textTransform: "uppercase",
    },
    // subtitle
    subtitle1: {
      color: "var(--3, #FFF)",
      fontFamily: "kippaxmodern_cndbd",
      fontSize: "36px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "normal",
      textTransform: "capitalize",
    },
    // asset description
    subtitle2: {
      color: "var(--3, #FFF)",
      fontFamily: "kippaxmodern_bd",
      fontSize: "24px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "normal",
    },
    // copy block
    body1: {
      color: "var(--3, #FFF)",
      fontFamily: "kippaxmodern_rg",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "normal",
    },
  },
  components: {
    MuiListItemButton: {
      defaultProps: {
        sx: {
          "&:hover": {
            color: "#3BD6FF",
            borderRadius: "6px",
          },
        },
      },
    },
    MuiIconButton: {
      defaultProps: {
        sx: {
          borderRadius: 1,
          "&:hover": {
            backgroundColor: "#3BD6FF4D",
            color: "#3BD6FF",
          },
          "&.MuiTouchRipple-root.MuiTouchRipple-child": {
            borderRadius: "6px",
          },
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          display: "list-item",
          listStyleType: "disc",
          color: "var(--3, #FFF)",
        },
      },
    },
    MuiSnackbarContent: {
      styleOverrides: {
        root: {
          background: "#001838",
          fontFamily: "kippaxmodern_rg",
          padding: "2px 20px",
          borderRadius: "8px",
          border: "2px solid #FFFFFF",
          minWidth: "100px !important",
          ".MuiIconButton-root": {
            visibility: "visible",
          },
        },
      },
    },
  },
});

const App = () => {

  useEffect(() => {
    if (TRACKING_ID) {
      ReactGA.initialize(TRACKING_ID);
    };
  }, []);

  return (
    <Box data-testid="app-component">
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <Layout>
            <Navigation/>
          </Layout>
        </BrowserRouter>
      </ThemeProvider>
    </Box>
  );
};

export default App;
